import { InputType } from '../../../../../../../_metronic/helpers'
import { CustomSelect, Input, Radio, TextEditor } from '../../../../../../components'
import { FormularioCampoView } from '../../core/_models'

export const renderField = (field: FormularioCampoView) => {
  switch (field.tipo) {
    case InputType.Select:
      const options = field.opcoes?.map((option) => ({
        value: option.descricao,
        label: option.descricao,
      }))

      return (
        <CustomSelect
          className='w-100'
          isMulti={field.multiplo}
          options={options}
          isRequired={field.obrigatorio}
          isDisabled={true}
          value={
            field.respostaPadrao
              ? { label: field.respostaPadrao, value: field.respostaPadrao }
              : undefined
          }
        />
      )
    case InputType.TextEditor:
      return <TextEditor value={field.respostaPadrao || ''} onChange={() => {}} disabled={true} />
    case InputType.Radio:
      return (
        <Radio
          id={String(field.id)}
          name={field.rotulo}
          value={field.respostaPadrao}
          options={field.opcoes.map((opt) => ({
            id: opt.id || opt.descricao,
            descricao: opt.descricao,
            value: opt.descricao,
          }))}
          disabled={true}
        />
      )
    default:
      return (
        <Input
          type={field.tipo === InputType.Number ? 'number' : 'text'}
          name={field.rotulo}
          required={field.obrigatorio}
          disabled={true}
          value={
            field.tipo === InputType.Number
              ? field.respostaPadrao !== ''
                ? Number(field.respostaPadrao)
                : undefined
              : field.respostaPadrao
          }
        />
      )
  }
}
